import { render, staticRenderFns } from "./createPageIndex.vue?vue&type=template&id=5f031ca4&scoped=true"
import script from "./createPageIndex.vue?vue&type=script&lang=js"
export * from "./createPageIndex.vue?vue&type=script&lang=js"
import style0 from "./createPageIndex.vue?vue&type=style&index=0&id=5f031ca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f031ca4",
  null
  
)

export default component.exports